<div class="replace-vehicle main">
  <div class="row">
    <div class="column twelve lg-push-two lg-eight">
      <h4 class="heading-sub-section">{{ changeCoverageHeaderText }}</h4>

      <form [formGroup]="riskSelectionForm" (ngSubmit)="riskSelectionSubmit()">
        <!-- The data has not come back yet -->
        @if (loading | async) {
          <ds-localized-spinner
            class="block pad-bottom-20"
            [dataLoading]="loading | async"
            [loadingMessage]="'Looking for vehicles...'"
          ></ds-localized-spinner>
        }

        @if ((loading | async) === false) {
          <div>
            <div class="row pad-bottom-10">
              <div class="column twelve">
                <fieldset>
                  <ds-risk-list
                    [preSelectedRisk]="preSelectedRisk"
                    [risks]="vehicles"
                    (riskChange)="changeRisk($event)"
                  >
                  </ds-risk-list>
                </fieldset>
              </div>
            </div>
          </div>
        }

        <div class="row">
          <div class="column twelve">
            <p
              dsContent
              [contentPath]="
                (isPartner$ | async) ? 'policy.editPolicyMessage' : 'policy.editVehicleMessage'
              "
            ></p>
          </div>
        </div>

        <div class="row callToAction">
          <div class="column twelve">
            <button
              ds-button
              type="submit"
              data-cy="continueButton"
              [disabled]="
                !riskSelectionForm?.valid || !riskSelectionForm.dirty || (loading | async)
              "
              [class.capitalize]="!isPartner"
              [class.continue-button]="(isPartner$ | async) === false"
            >
              {{ isPartner ? 'See Available Changes' : 'Continue' }}
            </button>
            <a
              class="pad-horizontal-20"
              (click)="cancel()"
              dsContent
              [contentPath]="'shared.cancel'"
            ></a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
